export default __webpack_public_path__ + "static/proj-6a0b73e308549e49b1450f776b556e5a.svg";